'use client';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Button, Container, FlexGrid, IntersectionProvider, useDisclosure } from '@honeycomb/ui-core';
import React from 'react';
import { FeatureFlagEnum, hasFeatureFlag, parseBoolean, useClearShortlist, useGlobalContext, useModal, useShortlist, } from '@honeycomb/data';
import { pushClearShortlist } from '@honeycomb/tracking';
import { EmptyWishlist } from './EmptyWishlist';
import { WishlistHeading } from './WishlistHeading';
import { WishlistHotelCard } from './WishlistHotelCard';
import { HotelReviewsDialog } from '../hotel/HotelReviewsDialog/HotelReviewsDialog';
export function WishlistDetails() {
    var _a, _b, _c;
    const { resourceStrings: { HC_WISHLIST_TITLE, HC_WISHLIST_DESCRIPTION, HC_WISHLIST_CLEAR_BUTTON_LABEL, HC_ERROR_MSG, APISUNSUBSCRIBEFAILHEADING, }, configSettings: { EnableShortlist }, } = useGlobalContext();
    const shortlistEnabled = parseBoolean(EnableShortlist) || hasFeatureFlag(FeatureFlagEnum.SHORTLIST);
    const { data: shortlistData, loading, called } = useShortlist([], !shortlistEnabled);
    const [clearShortlist, { loading: clearLoading }] = useClearShortlist([pushClearShortlist]);
    const [_, setCurrentModal] = useModal();
    const handleClear = React.useCallback((event) => __awaiter(this, void 0, void 0, function* () {
        var _d, _e;
        event.preventDefault();
        const clearData = yield clearShortlist();
        if (!((_e = (_d = clearData.data) === null || _d === void 0 ? void 0 : _d.clearShortlist) === null || _e === void 0 ? void 0 : _e.success)) {
            setCurrentModal({
                isOpen: true,
                heading: APISUNSUBSCRIBEFAILHEADING,
                subheading: HC_ERROR_MSG,
            });
        }
    }), [APISUNSUBSCRIBEFAILHEADING, HC_ERROR_MSG, clearShortlist, setCurrentModal]);
    // State for reviews dialog
    const [reviewsDialogOpen, { open: handleOpenReviewsDialog, close: handleCloseReviewsDialog }] = useDisclosure(false);
    const [reviewsDialogExited, setReviewsDialogExited] = React.useState(true);
    const [reviewDetails, setReviewDetails] = React.useState();
    const handleReviewsDialogTriggerClick = React.useCallback((origin, hotel) => {
        setReviewDetails({
            hotel,
            origin,
        });
        handleOpenReviewsDialog();
        setReviewsDialogExited(false);
    }, [handleOpenReviewsDialog]);
    if (!shortlistEnabled)
        return null;
    const estabsInShortlist = (_c = (_b = (_a = shortlistData === null || shortlistData === void 0 ? void 0 : shortlistData.getShortlist) === null || _a === void 0 ? void 0 : _a.hotels) === null || _b === void 0 ? void 0 : _b.map((hotel) => hotel.estabId.toString())) !== null && _c !== void 0 ? _c : [];
    const isLoading = loading || !called;
    const isEmpty = called && !loading && estabsInShortlist.length === 0;
    return (React.createElement(Container, { py: 5, pb: 20, mih: 500 },
        React.createElement(FlexGrid, { container: true, spacing: 4, alignItems: "flex-end", my: 2 },
            React.createElement(FlexGrid, { xs: 12, m: "fill" },
                React.createElement(WishlistHeading, { title: HC_WISHLIST_TITLE, description: HC_WISHLIST_DESCRIPTION, color: undefined, size: "m" })),
            !isEmpty && !isLoading && (React.createElement(FlexGrid, { xs: 12, m: "auto" },
                React.createElement(Button, { variant: "outlined", onClick: handleClear, fullWidth: { xs: true }, size: "m", "data-id": "wishlist_clear_button", disabled: clearLoading }, HC_WISHLIST_CLEAR_BUTTON_LABEL)))),
        isLoading && (React.createElement(FlexGrid, { container: true, spacing: 4, my: 2 }, [1, 2, 3].map((num) => (React.createElement(FlexGrid, { xs: 12, m: 6, l: 4, key: num },
            React.createElement(WishlistHotelCard, { onReviewsDialogTriggerClick: handleReviewsDialogTriggerClick })))))),
        !isEmpty && (React.createElement(React.Fragment, null,
            React.createElement(IntersectionProvider, null,
                React.createElement(FlexGrid, { container: true, spacing: 4, my: 2 }, estabsInShortlist.map((estabId) => {
                    return (React.createElement(FlexGrid, { xs: 12, m: 6, l: 4, key: estabId },
                        React.createElement(WishlistHotelCard, { estabId: estabId, onReviewsDialogTriggerClick: handleReviewsDialogTriggerClick })));
                }))),
            reviewDetails && (reviewsDialogOpen || !reviewsDialogExited) && (React.createElement(HotelReviewsDialog, { hotel: reviewDetails.hotel, origin: reviewDetails.origin, open: reviewsDialogOpen, onClose: handleCloseReviewsDialog, onExited: () => setReviewsDialogExited(true) })))),
        isEmpty && React.createElement(EmptyWishlist, null)));
}
